<template>
    <v-btn-toggle :value="selected?.value" color="primary" class="ma-n2 ma-lg-n4">
        <v-btn v-for="{ data, value } in items" :key="value" outlined small class="ma-2 ma-lg-4 min-w-80px min-w-lg-120px" v-bind="{ value }" @click="(application = { ...data }) && emit()"> {{ value }}</v-btn>
    </v-btn-toggle>
</template>

<script>
import dayjs from "dayjs";
import { initRecruitmentField__application } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initRecruitmentField__application }, // recruitment.application
    },
    data: () => ({
        application: initRecruitmentField__application(),
    }),
    computed: {
        selected() {
            return this.items.find((item, index) => {
                return !Object.keys(item.data).some((key) => {
                    if (key.includes("At") && this.value[key]) {
                        return dayjs(this.value[key]).format("YYYY-MM-DD") != item.data[key];
                    } else {
                        return this.value[key] != item.data[key];
                    }
                });
            });
        },
        items() {
            return [
                {
                    value: "1개월",
                    data: initRecruitmentField__application({
                        ...this.value,
                        startsAt: dayjs(this.value?.startsAt || Date.now()).format("YYYY-MM-DD"),
                        endsAt: dayjs(this.value?.startsAt || Date.now())
                            .add(1, "month")
                            .format("YYYY-MM-DD"),
                        isOpenHiring: false,
                    }),
                },
                {
                    value: "2개월",
                    data: initRecruitmentField__application({
                        ...this.value,
                        startsAt: dayjs(this.value?.startsAt || Date.now()).format("YYYY-MM-DD"),
                        endsAt: dayjs(this.value?.startsAt || Date.now())
                            .add(2, "month")
                            .format("YYYY-MM-DD"),
                        isOpenHiring: false,
                    }),
                },
                {
                    value: "3개월",
                    data: initRecruitmentField__application({
                        ...this.value,
                        startsAt: dayjs(this.value?.startsAt || Date.now()).format("YYYY-MM-DD"),
                        endsAt: dayjs(this.value?.startsAt || Date.now())
                            .add(3, "month")
                            .format("YYYY-MM-DD"),
                        isOpenHiring: false,
                    }),
                },
                {
                    value: "상시채용",
                    data: initRecruitmentField__application({
                        ...this.value,
                        startsAt: null,
                        endsAt: null,
                        isOpenHiring: true,
                    }),
                },
            ];
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.application = initRecruitmentField__application(this.value);
        },
        emit() {
            this.$emit("input", initRecruitmentField__application(this.application));
        },
    },
};
</script>

<style scoped lang="scss">
.v-btn-toggle:not(.v-btn-toggle--group) .v-btn{
    color: #666;
    border-color: #ddd !important;
    &::before{
        background-color: var(--v-primary-base);
    }
}
.v-btn-toggle:not(.v-btn-toggle--group) .theme--light.v-btn--active{
    color: var(--v-primary-base);
    border-color: var(--v-primary-base) !important;
}
.v-application--is-ltr .v-btn-toggle>.v-btn.v-btn:not(:first-child){
    border-left-width: 1px;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .v-btn:not(.v-btn--fab,.v-btn--icon).v-size--small {
        height: 32px;
        font-size: 1.6rem;
    }
}
@media (min-width:1200px){
}

</style>